
import React, { createContext, useState, useContext } from 'react';
import { removeLocalStorage, setLocalStorage, Utils } from '../../utils';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const signUp = (token) => {
    setIsAuthenticated(true);
    setLocalStorage(Utils.storageKeys.token, token);
  };


  const signIn = (token) => {
    setIsAuthenticated(true);
    setLocalStorage(Utils.storageKeys.token, token);
  };

  const signOut = () => {
    setIsAuthenticated(false);
    removeLocalStorage(Utils.storageKeys.token);
    removeLocalStorage(Utils.storageKeys.refreshToken);
    removeLocalStorage(Utils.storageKeys.userData);
    removeLocalStorage(Utils.storageKeys.currentSidebar);
    removeLocalStorage(Utils.storageKeys.thirdSidebar);
    removeLocalStorage(Utils.storageKeys.activeApp);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, signIn, signOut, signUp }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
